import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { StaticQuery, graphql } from "gatsby"

import Carousel from "../../atomic/molecules/Carousel"
import ProjectCard from "../../atomic/organisms/ProjectCard"
import { COLORS, TYPE } from "../../../theme/styles/globals"

class ContentfulBlockAllProjectList extends React.Component {

  

  render(){

    const { mode, title, accent, data, transition } = this.props
    const { projects } = data
    const { all } = projects

    return(
      <Container>
        <CarouselWrap>
          <Carousel
            id={"project-all-list"}
            mode={mode}
            slidesPerView={1.1}
            centeredSlides={true}
            spaceBetween={10}
          >
            {all.map((project, i) => (
              <ProjectCard
                title={all[i].project.title}
                client={all[i].project.client}
                slug={all[i].project.slug}
                award={all[i].project.award}
                image={all[i].project.landscapeImage}
                transition={transition}
                stacked="vertical"
                key={i}
              />
            ))}
          </Carousel>
        </CarouselWrap>
        <Projects>
        {all.map((item, i) => (
          <CardWrap mode={mode} key={i}>
            <ProjectCard
              title={item.project.title}
              client={item.project.client}
              slug={item.project.slug}
              award={item.project.award}
              services={item.project.services}
              image={item.project.portraitImage}
              mode={mode}
              transition={transition}
              stacked="horizontal"
            />
          </CardWrap>
        ))}
        </Projects>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  ${up('md')}{
    display:flex;
    flex-direction: row;
  }
`

const Projects  = styled.div`
  display:none;

  ${up('md')}{
    display:flex;
    align-items:center;
  }
`

const CarouselWrap = styled.div`
  display: block;
  padding-top: 30px;
  
  ${up("md")} {
    display: none;
  }
`

const CardWrap = styled.div`
  border-right: 1px dashed ${props => props.mode === "LIGHT" ? COLORS.LIGHT_GREY_2 : COLORS.LIGHT_GREY_4};
  height:100vh;
  display:flex;
  justify-content: center;
  align-items: center;
  margin-right:3vh;
  padding-left: 3vh;
  position:relative;
`

const query = graphql`
{
  projects: allContentfulProject(sort: { fields: updatedAt, order: DESC }, limit: 30) {
    all:edges {
      project:node {
        slug
        title
        client
        services
        portraitImage{
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        landscapeImage{
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        award
      }
    }
  }
}
`

export default props => (
  <StaticQuery
    query={query}
    render={data => <ContentfulBlockAllProjectList data={data} {...props} />}
  />
)